import { deleteObject, listAll, type StorageReference } from 'firebase/storage'

/**
 * DEV ONLY — recursively deletes every file under a Storage folder. A missing/empty
 * folder is not an error — listAll() just returns no items/prefixes.
 */
export async function deleteStorageFolder(folderRef: StorageReference): Promise<void> {
  const { items, prefixes } = await listAll(folderRef)
  await Promise.all([
    ...items.map((item) => deleteObject(item)),
    ...prefixes.map((subFolderRef) => deleteStorageFolder(subFolderRef)),
  ])
}
